import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Props from './ListingDetailsComponent';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import clsx from 'clsx';
import { getXssFilter } from 'checkout/helpers/helpers';
import * as fitvids from 'fitvids';
import Translation from "../../shared/Translation";
import { getMainEvent } from '../../checkout/selectors/event';
import { getShouldUseThemeDark } from '../../checkout/selectors/ui';

/**
 * props
 * description
 *
 */
class ListingDetails extends Component<Props> {
    componentDidMount() {
        fitvids();
        this.bodyRef = createRef();
    }
    getDescription = () => {
        let description = this.props.description;
        if (this.props.listingsConfig?.useEventContent === false) {
            description = this.props.listingsConfig.content;
        }
        return {__html: getXssFilter().process(description)};
    };

    getHeading = () => {
        let heading = <Translation>{'checkout__event_details'}</Translation>;
        if (this.props.listingsConfig && this.props.listingsConfig.heading) {
            heading = this.props.listingsConfig.heading;
        }

        return heading;
    };

    getWrapperClass = () => {
        let classString = "page-content__outer";

        if(this.props.theme) {
            classString += " "+this.props.theme;
        }

        return classString;
    }

    render() {
        const pageContentClassName = clsx('page__content', { 'theme--dark': this.props.shouldUseThemeDark });

        return(
            <div className={pageContentClassName}>
                <div className={this.getWrapperClass()}>
                    <div className="page-content__inner">
                        <div className="rich-content ">
                            <div className="rich-content__heading">
                                <h2 className="rich-content__heading-name">{this.getHeading()}</h2>
                            </div>
                            <div className="rich-content__body" ref={this.bodyRef} dangerouslySetInnerHTML={this.getDescription()}></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

ListingDetails.propTypes = {
    description: PropTypes.string.isRequired,
    theme: PropTypes.string
}

const mapStateToProps = (state, props) => {
    return {
        description: getMainEvent(state)?.event?.description ?? '',
        listingsConfig: state.ui.uiConfig?.listings ?? {},
        shouldUseThemeDark: getShouldUseThemeDark(state),
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(ListingDetails);


